
  <div class="block-options-container">
    <div class="block-options">

      <div class="block-type">
        <ng-container>
          <select [(ngModel)]="FitnessBlock.blockType" (change)="PrepareMetrics()" *ngIf="!PlanView">
            <option [value]="BlockType.Block">Block</option>
            <option [value]="BlockType.Circuit">Circuit</option>
            <option *ngIf="ShowWarmup" [value]="BlockType.Warmup">Warmup</option>
            <option *ngIf="ShowCooldown" [value]="BlockType.Cooldown">Cooldown</option>
          </select>
          <span *ngIf="PlanView">{{FitnessBlock.blockType == BlockType.Block ? 'Block' : 'Circuit'}}</span>
        </ng-container>
      </div>

      <div class="block-repeat-rest" *ngIf="FitnessBlock.blockType==BlockType.Circuit">
        <ng-container>
          <span>Repeat</span><br>
          <input type="number" fieldSize="tiny" nbInput [disabled]="FitnessBlock.blockType==BlockType.Block" (change)="PrepareMetrics()" [(ngModel)]="FitnessBlock.repetitionCount" min="1" *ngIf="!PlanView">
          <span *ngIf="PlanView">{{FitnessBlock.repetitionCount}}</span>
        </ng-container>
      </div>

      <div class="block-repeat-rest" *ngIf="FitnessBlock.blockType==BlockType.Circuit">
        <ng-container>
          <span>Rest</span><br>
          <input type="number" fieldSize="tiny" nbInput [disabled]="FitnessBlock.blockType==BlockType.Block" (change)="PrepareMetrics()" [(ngModel)]="FitnessBlock.circuitRest" min="0" *ngIf="!PlanView">
          <span *ngIf="PlanView">{{FitnessBlock.circuitRest}}</span>
        </ng-container>
      </div>

      <div class="block-repeat-rest" *ngIf="FitnessBlock.blockType==BlockType.Circuit">
        <ng-container>
          <span>Rest End</span><br>
          <input type="number" fieldSize="tiny" nbInput [disabled]="FitnessBlock.blockType==BlockType.Block" (change)="PrepareMetrics()" [(ngModel)]="FitnessBlock.restEnd" min="0" *ngIf="!PlanView">
          <span *ngIf="PlanView">{{FitnessBlock.restEnd}}</span>
        </ng-container>
      </div>
    </div>
  </div>
<nb-card class="nb-card">



  <nb-card-header>
    <div class="MealEditingLocation">
      <div class="block-name">
        <smart-edit #BlockNameEdit [(value)]="FitnessBlock.name" [readonly]="PlanView" [DisplaySecond]="true" [CallbackThis]="this" [(SecondDisplayCallback)]="UpdateBlockLabel" (keyup)="BlockNameChange($event)"></smart-edit>
      <div style="font-size:8pt; font-weight: 400;" *ngIf="FitnessBlock.blockType == BlockType.Circuit">
        <span>Circuit, repeat {{FitnessBlock.repetitionCount}}X, {{FitnessBlock.circuitRest}} sec. Rest </span>
      </div>
      
      </div>


   


    </div>

  </nb-card-header>

  <nb-card-body style="padding:0 0 !important; overflow: hidden;">

    <div class="row">
      <div class="col-lg-10 col-md-12">
        <app-fitness-items-list-presentation #FitnessItems [PatientID]="PatientID" [PatientName]="PatientName" [IsPreferredUnitImperial]="IsPreferredUnitImperial" [FitnessBlock]="FitnessBlock" [BlockType]="FitnessBlock.blockType" [CircuitRest]="FitnessBlock.circuitRest"  *ngIf="!PlanView"></app-fitness-items-list-presentation>
      </div>
      <div class="col-lg-2 col-md-12">
        <app-fitness-summary  #FitnessSummaryView
                                             class="Metrics {{PlanView ? 'plan-view' :''}}"
                                             [Exercises]="BlockExercises"
                                             [Reps]="BlockReps"
                                             [Minutes]="BlockMinutes">
        </app-fitness-summary>
      </div>
    </div>

</nb-card-body>
</nb-card>
